import React from 'react'
import styled from "styled-components"
import {Link} from "react-router-dom"
import {getImageUrl} from "../../other/axios"

const ItemLink = styled(Link)`
    text-decoration: none !important;
    transition: all 0.3s ease;
    outline: none;
    display: block;
    padding: 10px;

    &:hover, &:focus { 
        transform: scale(1.05); 
        z-index: 100; 
    }
`

const Poster = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 12px;
    background-size: cover;
    background-position: center;
    background-color: #1a1a1a;
    box-shadow: 0 10px 20px rgba(0,0,0,0.5);
    border: 1px solid rgba(255,255,255,0.1);
    position: relative;
    overflow: hidden;

    &:hover {
        border-color: #00d2ff;
        box-shadow: 0 0 20px rgba(0, 210, 255, 0.4);
    }
`

const Name = styled.p`
    color: #fff;
    margin-top: 8px;
    font-size: 0.85rem;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    opacity: 0.8;
`

const RowItem = ({stream_id, stream_icon, name, playingMode, style}) => {
    if (!stream_id) return null;
    
    // Garantimos que o card tenha um tamanho estável e não encolha em listas flex (GroupRow)
    const baseStyle = { 
        width: '180px', 
        height: '280px', 
        flexShrink: 0, 
        display: 'block' 
    };
    
    // Mesclamos o estilo base com o estilo vindo da grid virtual ou aplicamos margem se for lista horizontal
    const itemStyle = style ? { ...baseStyle, ...style } : { ...baseStyle, margin: '0 10px' };
    
    return (
        <div style={itemStyle}>
            <ItemLink to={`/${playingMode}/category/0/${stream_id}/info/`} style={{width: '100%', display: 'block'}}>
                <Poster style={{ height: '220px', width: '100%', position: 'relative', backgroundColor: '#1a1a1a' }}>
                    <img 
                        src={getImageUrl(stream_icon)} 
                        alt={name}
                        loading="lazy"
                        style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '12px' }}
                        onError={(e) => { e.target.src = "/img/no_cover.jpg"; }}
                    />
                    <div style={{position: 'absolute', bottom: 0, left: 0, width: '100%', height: '40%', background: 'linear-gradient(transparent, rgba(0,0,0,0.8))', pointerEvents: 'none'}}></div>
                </Poster>
                <Name style={{width: '100%'}}>{name}</Name>
            </ItemLink>
        </div>
    )
}

export default RowItem
